import React from 'react';

import styled from '@emotion/styled';

interface ValueCardProps {
  data: any;
  secondField?: string;
}
const ValueCard: React.FC<ValueCardProps> = ({ data, secondField }) => {
  return (
    <Container>
      {data.fleetPlateNumber}
      {secondField && ` (${data[secondField]})`}
    </Container>
  );
};

export default ValueCard;

const Container = styled.div`
  display: flex;
  gap: 12px;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
`;
